<template>
  <mdb-container class="main-container">
    <h1 class="h1-responsive mt-4 mb-3 text-center"><strong>Контактная информация</strong></h1>
    <section class="mb-3">
      <h2 class="h2-responsive mt-4 mb-3 text-center"><strong>Вопросы и общение</strong></h2>
      <mdb-row class="">
        <mdb-col md="12">
          <p class="text-center">
            Для общения с соратниками и связи с опытными инструкторами есть главная группа по кайтингу в Ульяновске в Вконтакте <a href="https://vk.com/ul_kite">SIMKITE</a>
          </p>
          <p class="text-center"><img class="content-image-320" :src="simKiteLogo"></p>
          <p class="text-center">
            <a href="https://vk.com/ul_kite">SimKite</a> - кайт клуб, ставящий перед собой задачу объединения любителей кайт спорта Ульяновска, а так же популяризацию и развитие самой идеи кайтбординга.
            Группа призвана анонсировать мероприятия кайт-клуба, служить площадкой для обсуждений кайт-новостей, а так же быть банком фотографий и видео-отчетов.
          </p>
          <p class="text-center">Выкладывайте фото с хештегами <a href="https://vk.com/feed?section=search&q=%23simkite">#simkite</a> <a href="https://vk.com/feed?section=search&q=%23ul_kite">#ul_kite</a> и их увидит весь город!</p>
        </mdb-col>
      </mdb-row>
      <h2 class="h2-responsive mt-4 mb-3 text-center"><strong>Контактные данные сайта</strong></h2>
      <mdb-row class="">
        <mdb-col md="12">
          <p class="px-10 text-center">
            <a class="blue-text">
              <h6 class="h6-responsive mb-3">
                <mdb-icon icon="envelope-open" class="pr-2" />E-Mail: contact@ulkite.ru
              </h6>
            </a>
          </p>
          <div class="pt-4 content-logo text-center mb-5">
            <img class="logo-main" :src="imgLogo" alt="ULKite.ru">
          </div>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
import { mdbContainer, mdbRow, mdbCol, mdbIcon } from 'mdbvue'
import imgLogo from '../../assets/logo/logo.svg'
import simKiteLogo from '../../assets/logo/simkite.jpg'

export default {
  name: 'ContactsPage',
  components: {
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbIcon
  },
  data: function () {
    return {
      imgLogo,
      simKiteLogo
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/ContactsPage.vue